<main>
  <loading-overlay [isLoading]="isLoading() > 0" />

  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <h1>{{ 'Departments_Title' | translateWF: 'Departments' }}</h1>
        <div class="page__title_buttons">
          <p-button label="{{ 'Add' | translateWF: 'Add' }}" icon="pi pi-plus" (onClick)="openModalDepartment(null)" />
        </div>
      </div>
    </div>

    <section>
      <div class="grid-2">
        <div class="span-2">
          <p-iconfield>
            <p-inputicon styleClass="pi pi-search" />
            <input
              type="text"
              pInputText
              class="min-w-[18.75rem]"
              placeholder="{{ 'Departments_Search_Placeholder' | translateWF: 'Search departments...' }}"
              [formControl]="searchControl"
            />
            @if (searchControl.value) {
              <p-inputicon styleClass="pi pi-times cursor-pointer" (click)="clearSearch()" style="right: 10px; left: auto" />
            }
          </p-iconfield>
        </div>
        <div class="span-2">
          <p-table [value]="departments()" [paginator]="true" [rows]="10" [rowsPerPageOptions]="[5, 10, 20]" selectionMode="single" [loading]="isLoading() > 0">
            <ng-template #header>
              <tr>
                <th>{{ 'Departments_Table_Department' | translateWF: 'Department' }}</th>
                <th>{{ 'Departments_Table_Description' | translateWF: 'Description' }}</th>
                <th>{{ 'Departments_Table_Members' | translateWF: 'Members' }}</th>
                <th>{{ 'Departments_Table_Managers' | translateWF: 'Managers' }}</th>
                <th></th>
              </tr>
            </ng-template>
            <ng-template #body let-department>
              <tr class="cursor-pointer">
                <td>{{ department.name | localized }}</td>
                <td>{{ department.description | localized }}</td>
                <td>
                  <p-tag [value]="getMembersCount(department).toString()" severity="info" />
                </td>
                <td>
                  <p-tag [value]="getManagersCount(department).toString()" severity="success" />
                </td>
                <td class="!text-end">
                  <p-button
                    variant="outlined"
                    icon="pi pi-pencil"
                    (onClick)="openModalDepartment(department)"
                    pTooltip="{{ 'Departments_Edit_Tooltip' | translateWF: 'Edit Department' }}"
                  />
                </td>
              </tr>
            </ng-template>
            <ng-template #empty>
              <tr>
                <td colspan="5" class="text-center py-4">
                  @if (searchControl.value) {
                    {{ 'Departments_Empty_Search' | translateWF: 'No departments found matching' }} "{{ searchControl.value }}"
                  } @else {
                    {{ 'Departments_Empty' | translateWF: 'No departments available' }}
                  }
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </section>
  </div>
</main>
